module.exports = ":host{\r\n    display:flex;\r\n    flex-direction:column;\r\n    height:100%;\r\n}"